import React from 'react';
import { cn } from '../lib/utils';

// Difficulty is intentionally OFF the green/black palette so levels are quickly
// distinguishable: Beginner=green, Intermediate=orange, Advanced=purple, Expert=red.
const MAP = {
  beginner: 'border-emerald/30 bg-emerald/15 text-emerald',
  intermediate: 'border-orange-500/30 bg-orange-500/15 text-orange-400',
  advanced: 'border-purple-500/30 bg-purple-500/15 text-purple-300',
  expert: 'border-rose-500/30 bg-rose-500/15 text-rose-400',
};

export function DifficultyBadge({ level, className }) {
  if (!level) return null;
  const cls = MAP[String(level).toLowerCase()] || 'border-white/10 bg-white/5 text-zinc-300';
  return (
    <span className={cn('inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold', cls, className)} data-testid="difficulty-badge">
      {level}
    </span>
  );
}
